/** Ready-to-paste briefs for Agent Builder, and the canned build that follows them. */

export const LEADGEN_BRIEF = `Build me a lead qualification agent for the marketing team.

Every morning, pull the new companies from Affinity and enrich them from Apollo: industry, sponsor (the PE or VC firm behind them), headcount, and the CEO. Score each one from 1 to 100 on fit for Oberon, and route every qualified lead to the proof point most likely to land with them: agents driving revenue, platform takeout, data at the frontline, or documents at volume.

When I ask for a batch, show me the ranked list and let me pick how many to draft. Draft one personalized email per lead in Gmail, addressed to the CEO by first name, naming their company and the proof point, and leave the drafts for a person to review. Never send anything on its own.

Give it a rich Outreach Studio UI alongside normal agent chat: pipeline counters, a ranked searchable prospect table, industry and fit filters, selectable batches, CEO contact details, transparent score explanations, proof-point matching, editable subject/body, and a mock integration activity feed. Use realistic fictional data and .example email addresses. All integration tools must be fast and visibly marked Mock; there must be no real delivery or external side effects. Include versioned tool-contract tests, unit tests, mocked UI flows, and explicitly soft safety-rubric checks. Preview the exact implemented revision, require plan approval and successful tests, and only add the agent to Your Agents when I choose Publish.`

export type BuildStep = { label: string; at: number }

/** Business-language checklist shown while the lead-gen agent is assembled. */
export const LEADGEN_BUILD_STEPS: BuildStep[] = [
  { label: 'Reading the brief', at: 900 },
  { label: 'Connecting to Affinity', at: 2300 },
  { label: 'Connecting to Apollo', at: 3700 },
  { label: 'Connecting to Gmail', at: 5100 },
  { label: 'Setting the scoring rules', at: 6600 },
  { label: 'Routing leads to proof points', at: 7900 },
  { label: 'Scheduling the 7:30 AM run', at: 9000 },
]
export const LEADGEN_BUILD_READY_AT = 10200
export const LEADGEN_BUILD_OPEN_AT = 11600
export const LEADGEN_BUILD_TARGET = '/apps/leadgen'

/** A brief that names the lead-gen tool chain is assembled by the canned build, not a live session. */
export function isLeadgenBrief(prompt: string): boolean {
  const text = prompt.toLowerCase()
  return text.includes('affinity') && text.includes('apollo')
}
